/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
import * as apiUserService from '../services/apiUserService'
import Autocomplete from 'react-autocomplete';
import Currency from './sub_components/currency'
class userDetailReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usersList: [],
            userDetail: {},
            isSearched: false
        };
    }
    async componentDidMount() {
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        this.setState({ accounts: userData.sub })
    }

    async onUserSearch(e, name, value) {
        if (value.length > 1) {
            this.setState({ [name]: value })
            let res = await userService.getUserSearch(this.state.accounts, value)
            let lst = []
            for (let x of res.usersList) {
                lst.push({ label: x, value: x, title: x, name: x })
            }
            lst.sort(function(a, b) {
                if(a.value.toLowerCase() < b.value.toLowerCase()) return -1;
                if(a.value.toLowerCase() > b.value.toLowerCase()) return 1;
                return 0;
            });
            this.setState({ usersList: lst })
        }
        else {
            this.setState({ [name]: value, usersList: [] })
        }
    }

    async onSelectedUser(user_id) {
        let userDetail = await apiUserService.getDashboard(user_id)

        this.setState({ userDetail: {}, user_id: "", isSearched: false },
            ()=>{
                this.setState({ userDetail: userDetail, user_id: user_id, isSearched: true })
            }
        )
    }


    render() {
        let usr = this.state.userDetail
        let parent = "";
        if (this.state.isSearched) {
            for (let pat of usr.parents) {
                if (pat === this.state.accounts) {
                    parent += pat
                    break
                }
                else {
                    parent += pat + " -> "
                }
            }
        }
        const availableBalance = !!usr ?( usr.role === 'Client' ? (parseFloat(usr.exposure) + parseFloat(usr.balance) + parseFloat(usr.upLineBalance)) : usr.availableBalance ): "";
        return (
            <div className="bethubs">
                <Header history = {this.props.history} />
                <div className="wrapper">
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box">
                                    <h5 className="text-blue">User Details</h5>
                                    <div className="row mt-2">
                                        <div className="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
                                            <div className="form-group font-12 autocomplete-wrapper">
                                                <Autocomplete
                                                    value={this.state.user_id}
                                                    items={this.state.usersList}
                                                    getItemValue={item => item.title}
                                                    renderItem={(item, isHighlighted) =>
                                                        <div className={`item ${isHighlighted ? 'selected-item' : ''}`}>
                                                            {item.title}
                                                        </div>
                                                    }
                                                    inputProps={{ placeholder: 'Search by client' }}
                                                    name="user_id"
                                                    onChange={(event, user_id) => this.onUserSearch(event, "user_id", user_id)}
                                                    onSelect={user_id => this.onSelectedUser(user_id)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {!!this.state.isSearched &&
                                        <div className="row">
                                            <div className="col-12 col-sm-12 col-md-12">
                                                <div className="market-analysis-user-details mb-3">
                                                    <fieldset>
                                                        <legend>User Details:</legend>
                                                        <ul className="row user-datails-popup">
                                                            <li className="w-50">
                                                                <label className="text-left">User Name :</label><span className="text-right">{!!usr.username ? usr.username : ""} </span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Role :</label><span className="text-right">{!!usr.role ? usr.role : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Client Name :</label><span className="text-right"> {!!usr.name ? usr.name : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Reference Name :</label><span className="text-right">{!!usr.referenceName ? usr.referenceName : ""} </span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Email :</label><span className="text-right">{!!usr.email ? usr.email : ""}  </span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Mobile  :</label><span className="text-right"> {!!usr.mobile ? usr.mobile : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">City :</label><span className="text-right">{!!usr.city ? usr.city : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Remarks :</label><span className="text-right">{!!usr.remarks ? usr.remarks : ""}</span>
                                                            </li>
                                                            <li className="w-100">
                                                                <label className="text-left">Parents :</label> <span className="text-right">{!!parent ? parent : ""}</span>
                                                            </li>
                                                        </ul>
                                                    </fieldset>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-12">
                                                <div className="market-analysis-user-details mb-3">
                                                    <fieldset>
                                                        <legend>Account Details:</legend>
                                                        <ul className="row user-datails-popup">
                                                            <li className="w-50">
                                                                <label className="text-left">Credit Ref:</label><span className="text-right"> {!!usr.creditRef ? usr.creditRef : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Balance:</label><span className="text-right">{!!usr.balance ? usr.balance : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                            <label className="text-left">Available Balance:</label><span className="text-right">{!!availableBalance ? <Currency key={"amt_amt_"} className="fbold" amount={availableBalance} showColor={false} /> : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">P/L : </label><span className="text-right">{!!usr.pnl ? <Currency key={"amt_amt_"} className="fbold" amount={usr.pnl} showColor={false} /> : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">UpLine Balance:</label><span className="text-right"> {!!usr.upLineBalance ? <Currency key={"usrdeup_amt_"} className="fbold" amount={usr.upLineBalance} showColor={false} /> : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">DownLine Balance: </label><span className="text-right">{!!usr.downLineBalance ? <Currency key={"usrdedl_amt_"} className="fbold" amount={usr.downLineBalance} showColor={false} /> : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Exposure :  </label><span className="text-right">{!!usr.exposure ? <Currency key={"usrdeex_amt_"} className="fbold" amount={usr.exposure} showColor={false} /> : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Max Profit:  </label><span className="text-right">{!!usr.maxProfit ? usr.maxProfit : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Max Bet: </label><span className="text-right">{!!usr.maxBet ? usr.maxBet : ""}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Bet Lock: </label><span className="text-right">{usr.betLock ? "Yes" : "No"}</span>
                                                            </li>
                                                            <li className="w-50">
                                                                <label className="text-left">Active : </label><span className="text-right">{usr.isActive ? "Yes" : "No"}</span>
                                                            </li>
                                                        </ul>
                                                    </fieldset>
                                                </div>
                                            </div>
                                            {/* <span>Name : {!!usr.name ? usr.name : ""}</span><br />
                                            <span>User Name : {!!usr.username ? usr.username : ""}</span><br/>
                                            <span>Email : {!!usr.email ? usr.email : ""}</span><br/>
                                            <span>Mobile : {!!usr.mobile ? usr.mobile : ""}</span><br/>
                                            <span>City : {!!usr.city ? usr.city : ""}</span><br/>
                                            <span>Remarks : {!!usr.remarks ? usr.remarks : ""}</span><br/>
                                            <span>Reference Name : {!!usr.referenceName ? usr.referenceName : ""}</span><br/>
                                            <span>Role : {!!usr.role ? usr.role : ""}</span><br/> */}
                                            {/* <span>Credit Ref : {!!usr.creditRef ? usr.creditRef : ""}</span><br/>
                                            <span>Balance : {!!usr.balance ? usr.balance : ""}</span><br/>
                                            <span>Available Balance : {!!usr.availableBalance ? usr.availableBalance : ""}</span><br/> */}
                                            {/* <span>UpLine Balance : {!!usr.upLineBalance ? usr.upLineBalance : ""}</span><br/> */}
                                            {/* <span>DownLine Balance : {!!usr.downLineBalance ? usr.downLineBalance : ""}</span><br/> */}
                                            {/* <span>P/L : {!!usr.pnl ? usr.pnl : ""}</span><br/> */}
                                            {/* <span>Exposure : {!!usr.exposure ? usr.exposure : ""}</span><br/> */}
                                            {/* <span>Max Profit : {!!usr.maxProfit ? usr.maxProfit : ""}</span><br/> */}
                                            {/* <span>Max Bet : {!!usr.maxBet ? usr.maxBet : ""}</span><br/> */}
                                            {/* <span>Parents :- jig - office - sduhgi - uygu - tyfvuyt - yusg</span><br/> */}
                                            {/* <span>Bet Lock : {usr.betLock ? "Yes" : "No"}</span><br/> */}
                                            {/* <span>Active : { usr.isActive ? "Yes" : "No"}</span><br/> */}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                <Footer />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(userDetailReport);